import React from 'react';
import {Link} from "react-router-dom";
import ScoutingInvitesCard from "./ScoutingInvitesCard";

class ScoutingRejectInvitesCard extends ScoutingInvitesCard {

    extraCardClass = () => {
        return 'scouting-reject-invites-card';
    }

    leftFooter = () => {
        return (
            <div className="left-side">
                <span className="reject-time">Scouting Rejected | 12/31/2020</span>
            </div>
        );
    }

    rightFooter = () => {
        return (
            <div className="right-side">
                <Link to="/scouting/full-profile" className="btn secondary sm">Player Details</Link>
            </div>
        );
    }
}

export default ScoutingRejectInvitesCard;
